const link_list = {
    routePath: 'applications',
    actionName: 'count',
    iconClass: 'fa-solid fa-file',
    title: 'My Active Application',
    search: {
        status: {
            key: 'status',
            value: ["Under development","Application ready for review","Technical review","Budget Review","ED approval","Pending submission","Under review"],
        },
    },
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }